import { useSearchParams, useNavigate } from "react-router-dom";
import Card from "../components/Card";
import Button from "../components/Button";
import { useTheme } from "../hooks/useTheme";
import { formatNumber } from "../utils/format";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { theme } = useTheme();

  const statusCode = searchParams.get("status_code") || "—";
  const refId = searchParams.get("ref_id") || "—";
  const amount = searchParams.get("amount") || "0";

  // The backend already passes the credited amount in Toman — display it directly.
  const toman = formatNumber(amount);

  return (
    <div data-theme={theme} className="min-h-screen bg-surface-base flex items-center justify-center p-4">
      <Card className="max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="w-16 h-16 rounded-full bg-status-success bg-opacity-20 flex items-center justify-center mx-auto mb-5">
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-primary"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-h1 text-text-main mb-2">پرداخت موفق</h1>
        <p className="text-body text-text-secondary mb-6">
          موجودی کیف پول شما با موفقیت افزایش یافت
        </p>

        {/* Amount Highlight */}
        <div className="bg-primary/5 rounded-btn p-4 mb-6">
          <p className="text-small text-text-tertiary mb-1">مبلغ واریز شده</p>
          <p className="text-[28px] font-semibold text-primary font-number">
            {toman}
            <span className="text-base text-text-tertiary font-normal mr-2">تومان</span>
          </p>
        </div>

        {/* Receipt Details */}
        <div className="bg-surface-hover rounded-btn p-4 mb-6 text-right space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-small text-text-tertiary">کد وضعیت</span>
            <span className="text-body font-number text-text-main font-medium" dir="ltr">
              {statusCode}
            </span>
          </div>
          <div className="border-t border-line" />
          <div className="flex items-center justify-between">
            <span className="text-small text-text-tertiary">کد رهگیری (زرین‌پال)</span>
            <span className="text-body font-number text-text-main font-medium" dir="ltr">
              {refId}
            </span>
          </div>
          <div className="border-t border-line" />
          <div className="flex items-center justify-between">
            <span className="text-small text-text-tertiary">تاریخ</span>
            <span className="text-body text-text-main">
              {new Date().toLocaleDateString("fa-IR")}
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <Button
            className="w-full !py-3"
            onClick={() => navigate("/wallet")}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            بازگشت به کیف پول
          </Button>
        </div>

        <p className="text-small text-text-tertiary mt-6">
          رسید پرداخت برای شما ایمیل خواهد شد
        </p>
      </Card>
    </div>
  );
}